import _default from './Item';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Item/index.js
// module id = 999
// module chunks = 0